import { useEffect, useState } from "react";
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { api } from "../api";
import { PageHeader } from "../components/PageHeader";
export function AuditPage() {
  const [rows, setRows] = useState<any[]>([]);
  useEffect(() => {
    api<{ auditLogs: any[] }>("/admin/audit-logs?pageSize=100").then((r) =>
      setRows(r.auditLogs),
    );
  }, []);
  return (
    <>
      <PageHeader
        title="Audit trail"
        subtitle="Immutable record of administrative changes and sensitive document access."
      />
      <Card>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Time</TableCell>
              <TableCell>Actor</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Target</TableCell>
              <TableCell>Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.id}>
                <TableCell>{new Date(r.created_at).toLocaleString()}</TableCell>
                <TableCell>
                  <Typography variant="body2">{r.actor_email}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {r.actor_role}
                  </Typography>
                </TableCell>
                <TableCell>{r.action}</TableCell>
                <TableCell>
                  {r.target_type}
                  <br />
                  <span className="mono">{r.target_id}</span>
                </TableCell>
                <TableCell>
                  <Typography variant="caption" className="mono">
                    {r.details_json}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </>
  );
}
